import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { AppService } from '../app.service';
import { messageService } from '../message.service';
import { SuccessSnackbarComponent } from '../support/success-snackbar/success-snackbar.component';
import { PopupData } from '../users/users.component';
import { PaginationService } from '../PaginationService';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { EditorConfig, ST_BUTTONS } from 'ngx-simple-text-editor';
import { DatepickerDateCustomClasses, BsDatepickerDirective } from 'ngx-bootstrap/datepicker';
import { DynamicAuditTrailComponent } from '../support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from '../support/excel-pdf/excel-pdf.component';
import { EditorComponent } from '../editor/editor.component';
import { GridReorderComponent } from '../grid-reorder/grid-reorder.component';
import { zonedTimeToUtc } from 'date-fns-tz';
import { qmsService } from '../qms/qms.service';

@Component({
  selector: 'app-scheduled-trainings',
  templateUrl: './scheduled-trainings.component.html',
  styleUrls: ['./scheduled-trainings.component.scss']
})
export class ScheduledTrainingsComponent implements OnInit {
  searchText: any;
  searchValue: any;
  isProcessing = true;
  _temp: any = {};
  columnLists: any = {};
  scheduledTrainingDataForGrid: any = [];
  makeStickyColumns: any;
  dataTypeList: any = [];
  userprivDetails: any = {};
  feedbackTemplateList: any = [];
  modeSearchText: string = '';
  categorySearchText: string = '';
  languageSearchText: string = '';
  designationSearchText: string = '';
  departmentSearchText: string = '';
  isShowTrainingAssessmentFlag: boolean = false;
  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }

  constructor(public dialog: MatDialog, private readonly appService: AppService, public qmsservice: qmsService, public readonly router: Router, private readonly snackBar: MatSnackBar,
    public paginationService: PaginationService, public message: messageService, private readonly elem: ElementRef) { }

  visibleDataGrid: boolean = false;
  auditTrail: any = {};
  visibleAuditTrail: boolean = false;
  itemsPerPage = 5; // Number of items to display per page
  currentPage = 1; // Current page number
  totalPages = 0; // Total number of pages

  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;

  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  private readonly users: any[];
  pager: any = {};
  pagedItems: any[];
  error = '';
  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.scheduledTrainingDataForGrid.length, page, this.perPage, targetpage);
    this.pagedItems = this.scheduledTrainingDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  getClobData(list: any, colunName: any, event: any) {
    event.stopPropagation();
    this.isProcessing = true;
    let docObj = {
      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: list.tablevwname,
      columnName: colunName
    }
    this.htmlContent = "";
    this.appService.getClobToViewAudit(docObj).subscribe({
      next: (Response: any) => {
        console.log(Response.result);
        this.htmlContent = Response.result;
        this.editorComponent.openEditor(this.htmlContent, colunName);
      }, error: (error) => {
        console.log(error);
      }
    })
    this.isProcessing = false;

  }
  htmlContent: any;
  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  getcallMethod() {
    this.isProcessing = true;
    this.scheduledTrainingDataForGrid = [];
    const data = {

      gridName: "SCHEDULED_TRAININGS"
    };
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {
        response.orderByClause ??= "UPDATED_ON DESC";

        this.makeStickyColumns = response.fixedFieldCnt;

        const data1: any = {

          gridName: "TMS_SCHEDULED_TRAININGS_GRID_VW",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          chartStatus: this.qmsservice.activity.chartStatus,
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || ""
        }
        this.reportObj = { ...data1, ...data };
        this.dynamicLabelCall();
        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.scheduledTrainingDataForGrid = response1;
            this.visibleAuditTrail = false;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            let rendereddata: any;
            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const size of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(size + 'px');
            }

            for (let y = this.columnLists.columnsListarray.length - 1; y >= 0; y--) {
              const column = this.columnLists.columnsListarray[y];

              if (this.columnLists.invisibleColumnarray.some((invCol: any) => invCol === column)) {
                this.columnLists.columnsListarray.splice(y, 1);
                this.columnLists.fieldColumnarray.splice(y, 1);
                this.columnLists.fieldSizeListArray.splice(y, 1);
              }
            }

            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe({
              next: (response2: any) => {
                this.dataTypeList = response2;
                for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                  this.columnLists.columnsListarray1.push({});
                  this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                  this.columnLists.columnsListarray1[m].dataType = "textbox";
                  this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                  for (const dataType of this.dataTypeList) {
                    if (dataType.columnName == this.columnLists.columnsListarray[m]) {
                      this.columnLists.columnsListarray1[m].dataType = dataType.fieldType;
                    }
                  }
                }
                for (const rowData of this.scheduledTrainingDataForGrid) {
                  for (const dataType of this.dataTypeList) {
                    if (dataType.fieldType == 'CHECKBOX') {
                      rowData[dataType.columnName] = rowData[dataType.columnName] == "Y";
                    }
                  }
                }
                this.calculateTotalPages = this.collectionSize / this.perPage;
                this.pager.totalPages = undefined;
                this.setPage(1, 0);
              }, error: (error) => {
                this.isProcessing = false;
                throw error;
              }
            });
            this.message.gridList = this.scheduledTrainingDataForGrid;
            this.collectionSize = this.scheduledTrainingDataForGrid.length;
            this.totalPages = Math.ceil(this.scheduledTrainingDataForGrid.length / this.itemsPerPage);
          }, error: (error) => {
            this.isProcessing = false
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });



  }

  dropDownForCategories: any = [];
  dropDownForLangauge: any = [];
  dropDownForMode: any = [];
  designationCodeDropdown: any = [];
  departmentCodeDropdown: any = [];
  dropDownForDesignationCode: any;
  dropDownForDepartmentCode: any;
  dateTimePickerConfiguration = {
    dateInputFormat: 'DD-MMM-YYYY HH:mm:ss',
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center',
    withTimepicker: true,
    useSeconds: true,
    keepDatepickerOpened: true,
    //initCurrentTime: true
  }
  dateCustomClasses: DatepickerDateCustomClasses[];
  isShowAddButtonToInst: boolean = false;
  ngOnInit() {
    const currentUserId = this.message.getUserId();
    this.appService.userPrivsDetails(currentUserId).subscribe((response: any = {}) => {
      this.userprivDetails = response;
      if (this.userprivDetails.trainingUserRoles.includes("Instructor Training Administrator")) {
        this.isShowAddButtonToInst = true;
      } else {
        this.isShowAddButtonToInst = false;
      }
    })
    this.appService.getCategoriesList().subscribe((data: any) => {
      this.dropDownForCategories = data;
      this.selectBoxeForCategory();
    })
    this.appService.getCodeListsByGroup("TRAINING_LANGUAGE").subscribe((data: any) => {
      this.dropDownForLangauge = data;
      this.selectBoxeForLanguage();
    })
    this.appService.getFeedbackTemplatesList().subscribe((data: any) => {
      this.feedbackTemplateList = data;
    })
    this.appService.getNonOrgCodeListsByGroupName("TRAINING_MODE").subscribe((data: any) => {
      this.dropDownForMode = data;
      this.selectBoxeForMode();
    })
    this.dropDownForDesignationCode = JSON.parse(sessionStorage.getItem('dropDownForDesignationCode') || '{}');
    this.dropDownForDepartmentCode = JSON.parse(sessionStorage.getItem('dropDownForDepartmentCode') || '{}');
    this.selectBoxeForDesignationCode();
    this.selectBoxeForDepartmentCode();

    const now = new Date();
    let groupandmodule = {

    };
    this.appService.getSchuduleTrainingGridChartCountsDetails(groupandmodule).subscribe((value) => {
      this.getChartCounts(value);
    });
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();

    if (filter === '') {
      this.pagedItems = this.scheduledTrainingDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.scheduledTrainingDataForGrid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)

      );
    }
  }

  @ViewChild('datePicker', { static: false }) datepicker!: BsDatepickerDirective;
  onDateChange(datepicker: BsDatepickerDirective): void {
    setTimeout(() => {
      datepicker.show();
    }, 0);
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }

      index1++;
    })


    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          column.style.background = 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }

    })
  }

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;
  onClick() {
    console.log("")
  }
  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked) {
      this.childCheckBoxs = true;
      for (const trainingData of this.scheduledTrainingDataForGrid) {
        trainingData.childCheckBoxs = true;
      }
    } else {
      this.childCheckBoxs = false;
      for (const trainingData of this.scheduledTrainingDataForGrid) {
        trainingData.childCheckBoxs = false;
      }
    }
  }

  priviousSelectedValue: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.priviousSelectedValue != undefined) {
        this.scheduledTrainingDataForGrid[this.priviousSelectedValue].childCheckBoxs = false;
      }
      list.childCheckBoxs = true;
      this.auditTrail.refNo = list.TRAINING_SCHEDULE_ID;
    } else {
      list.childCheckBoxs = false;
    }
    this.priviousSelectedValue = idx;
    this.visibleAuditTrail = this.scheduledTrainingDataForGrid.some((list: any) => list.childCheckBoxs);
  }

  validateNumberFields(event: KeyboardEvent) {
    const forbiddenKeys = ['E', 'e', '-', '*', '+', '.'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  todayDate = new Date();
  trainingName: any;
  trainerId: any;
  scheduleStartDate: any;
  scheduleEndDate: any;
  mode: any;
  trainingNameRequiredMsg: any;
  trainerRequiredMsg: any;
  scheduleStartDateRequireMsg: any;
  scheduleEndDateRequireMsg: any
  modeRequiredMsg: any;

  fieldValidation() {
    this.trainingName = document.getElementById('training') as HTMLInputElement;
    this.trainerId = document.getElementById('userName') as HTMLInputElement;
    this.scheduleStartDate = document.getElementById('scheduleStartDate') as HTMLInputElement;
    this.scheduleEndDate = document.getElementById('scheduleEndDate') as HTMLInputElement;
    this.mode = document.getElementById('trainingMode') as HTMLInputElement;
    this.trainingNameRequiredMsg = document.getElementById('training-required-msg') as HTMLInputElement;
    this.trainerRequiredMsg = document.getElementById('userName-required-msg') as HTMLInputElement;
    this.scheduleStartDateRequireMsg = document.getElementById('scheduleStartDate-required-msg') as HTMLInputElement;
    this.scheduleEndDateRequireMsg = document.getElementById('scheduleEndDate-required-msg') as HTMLInputElement;
    this.modeRequiredMsg = document.getElementById('trainingMode-required-msg') as HTMLInputElement;
    if (this.scheduledTrainingFieldData.trainingName == null) {
      this.trainingName.style.border = '1px solid red';
      this.trainingNameRequiredMsg.style.display = 'block';
    } else {
      this.trainingName.style.border = 'none';
      this.trainingNameRequiredMsg.style.display = 'none';
    }

    if (this.scheduledTrainingFieldData.trainerId == null) {
      this.trainerId.style.border = '1px solid red';
      this.trainerRequiredMsg.style.display = 'block';
    } else {
      this.trainerId.style.border = 'none';
      this.trainerRequiredMsg.style.display = 'none';
    }

    if (this.scheduledTrainingFieldData.scheduledStartDate == null) {
      this.scheduleStartDate.style.border = '1px solid red';
      this.scheduleStartDateRequireMsg.style.display = 'block';
    } else {
      this.scheduleStartDate.style.border = 'none';
      this.scheduleStartDateRequireMsg.style.display = 'none';
    }

    if (this.scheduledTrainingFieldData.scheduledEndDate == null) {
      this.scheduleEndDate.style.border = '1px solid red';
      this.scheduleEndDateRequireMsg.style.display = 'block';
    } else {
      this.scheduleEndDate.style.border = 'none';
      this.scheduleEndDateRequireMsg.style.display = 'none';
    }

    if (this.selectedTrainingModeValue == null || this.selectedTrainingModeValue == "") {
      this.mode.style.border = '1px solid red';
      this.modeRequiredMsg.style.display = 'block';
    } else {
      this.mode.style.border = 'none';
      this.modeRequiredMsg.style.display = 'none';
    }
  }


  scheduledTrainingFieldData: any = {};
  operationFlag: any;
  popupDataTitle: PopupData = {
    title: ''
  };

  popupTitle: string | null = 'title';
  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  @ViewChild('searchTraining', { static: true }) searchTraining: TemplateRef<any>;
  @ViewChild('searchUser', { static: true }) searchUser: TemplateRef<any>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;
  visibleSearchTrainingPopup: MatDialogRef<TemplateRef<any>>;
  visibleSearchUserPopup: MatDialogRef<TemplateRef<any>>;

  searchTrainingConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  searchUserConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };
  addAndEditPopupConfig = {
    width: '70%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '20px' },
  };

  deletePopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  visibleAddButton: boolean;
  visibleEditButton: boolean;
  visibleReasonForUpdateField: boolean;
  openAddPopup() {
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.visibleReasonForUpdateField = false;
    this.operationFlag = 'ADD';
    this.popupDataTitle.title = "Create Instructor Training";
    this.scheduledTrainingFieldData = {};
    this.scheduledTrainingFieldData.trainingId = null;
    this.scheduledTrainingFieldData.version = null;
    this.scheduledTrainingFieldData.trainingDetails = null;
    this.scheduledTrainingFieldData.trainingName = null;
    this.scheduledTrainingFieldData.trainerId = null;
    this.scheduledTrainingFieldData.trainerName = null;
    this.scheduledTrainingFieldData.trainingMode = null;
    this.scheduledTrainingFieldData.trainingModeDetails = null;
    this.scheduledTrainingFieldData.scheduledStartDate = null;
    this.scheduledTrainingFieldData.scheduledEndDate = null;
    this.scheduledTrainingFieldData.actualStartDate = null;
    this.scheduledTrainingFieldData.actualEndDate = null;
    this.scheduledTrainingFieldData.durationInMins = null;
    this.scheduledTrainingFieldData.allowedFailedAttempts = null;
    this.scheduledTrainingFieldData.allowedFailedAttemptsAfterUnlock = null;
    this.scheduledTrainingFieldData.maxAllowedFailedAttempts = null;
    this.selectedTrainingMode = [];
    this.selectedTrainingModeValue = null;
    this.scheduledTrainingFieldData.allowUsersToTakeAssessmentAtApplication1 = false;
    this.scheduledTrainingFieldData.assessmentDueInDays = null;
    this.dateCustomClasses = [{ date: new Date(), classes: ['bg-warning'] }];
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  previousData: any;
  getTmsGroupsVwData: any = [];
  openEditPopup(editRowData: any) {
    this.isProcessing = true;
    console.log(editRowData);
    this.previousData = editRowData;
    this.visibleAddButton = false;
    this.visibleEditButton = true;
    this.visibleReasonForUpdateField = true;
    this.operationFlag = 'EDIT';
    this.popupDataTitle.title = "Update Instructor Training";
    this.appService.getScheduledTrainingById(editRowData.TRAINING_SCHEDULE_ID).subscribe((response: any) => {
      this.scheduledTrainingFieldData = response[0];
      this.isProcessing = false;
    })

  }

  refreshGridData() {
    this.isProcessing = true;
    this.getcallMethod();
  }

  config: EditorConfig = {
    placeholder: '',
    buttons: ST_BUTTONS,
  };
  openSnackbar: any;
  addAndEditFunction(scheduledTrainingFieldData: any) {
    this.isProcessing = true;
    if (scheduledTrainingFieldData.trainingName == null || scheduledTrainingFieldData.trainerId == null ||
      scheduledTrainingFieldData.scheduledStartDate == null || scheduledTrainingFieldData.scheduledEndDate == null
      || this.selectedTrainingModeValue == null || this.selectedTrainingModeValue == "") {
      this.fieldValidation();
      this.isProcessing = false;
    } else if (scheduledTrainingFieldData.scheduledStartDate && scheduledTrainingFieldData.scheduledEndDate && (scheduledTrainingFieldData.scheduledEndDate <= scheduledTrainingFieldData.scheduledStartDate)) {

      alert('Scheduled End Date should be greater  then  Scheduled Start Date');
      this.isProcessing = false;
    } else if (scheduledTrainingFieldData.actualStartDate && scheduledTrainingFieldData.actualEndDate && (scheduledTrainingFieldData.actualEndDate <= scheduledTrainingFieldData.actualStartDate)) {

      alert('Actual End Date should be greater then Actual Start Date');
      this.isProcessing = false;
    } else {
      if (this.operationFlag == 'ADD') {
        scheduledTrainingFieldData.allowUsersToTakeAssessmentAtApplication = this.scheduledTrainingFieldData.allowUsersToTakeAssessmentAtApplication1 == true ? 'Y' : 'N';
        scheduledTrainingFieldData.trainingMode = this.selectedTrainingModeValue;

        const userTimezone = localStorage.getItem('timezone') || 'Asia/Kolkata';
        const browserSelectedStartDate: Date = scheduledTrainingFieldData.scheduledStartDate;
        const utcStartDate = zonedTimeToUtc(browserSelectedStartDate, userTimezone);
        scheduledTrainingFieldData.scheduledStartDate = utcStartDate.toISOString();

        const browserSelectedEndDate: Date = scheduledTrainingFieldData.scheduledEndDate;
        const utcEndDate = zonedTimeToUtc(browserSelectedEndDate, userTimezone);
        scheduledTrainingFieldData.scheduledEndDate = utcEndDate.toISOString();


        this.appService.addScheduledTraining(scheduledTrainingFieldData).subscribe({
          next: (Response: any) => {
            if (Response.resultType == 'S') {
              this.visibleAddAndEditPopup.close();
              this.getcallMethod();
            }
            this.isProcessing = false;
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: Response.resultType == 'S' ? 5000 : undefined,
              data: {
                message: Response.result,
                type: Response.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok",
                pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
            this.isProcessing = false;
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      } else {
        delete scheduledTrainingFieldData.createdOn;
        delete scheduledTrainingFieldData.updatedOn;

        scheduledTrainingFieldData.allowUsersToTakeAssessmentAtApplication = this.scheduledTrainingFieldData.allowUsersToTakeAssessmentAtApplication1 ? 'Y' : 'N';
        if (scheduledTrainingFieldData.scheduledStartDate) {
          const scheduledStartDateValue = new Date(scheduledTrainingFieldData.scheduledStartDate);
          scheduledTrainingFieldData.scheduledStartDate = this.appService.dateZoneConvertion(scheduledStartDateValue);
        }
        if (scheduledTrainingFieldData.scheduledEndDate) {
          const scheduledEndDateValue = new Date(scheduledTrainingFieldData.scheduledEndDate);
          scheduledTrainingFieldData.scheduledEndDate = this.appService.dateZoneConvertion(scheduledEndDateValue);
        }
        if (scheduledTrainingFieldData.actualStartDate) {
          const actualStartDateValue = new Date(scheduledTrainingFieldData.actualStartDate);
          scheduledTrainingFieldData.actualStartDate = this.appService.dateZoneConvertion(actualStartDateValue);
        }
        if (scheduledTrainingFieldData.actualEndDate) {
          const actualEndDateValue = new Date(scheduledTrainingFieldData.actualEndDate);
          scheduledTrainingFieldData.actualEndDate = this.appService.dateZoneConvertion(actualEndDateValue);
        }
        this.appService.updateScheduledTraining(scheduledTrainingFieldData).subscribe({
          next: (Response: any) => {
            if (Response.resultType == 'S') {
              this.visibleAddAndEditPopup.close();
              this.getcallMethod();
            }
            this.isProcessing = false;
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: Response.resultType == 'S' ? 5000 : undefined,
              data: {
                message: Response.result,
                type: Response.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok",
                pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
            this.isProcessing = false;
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });

      }
    }
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
  }

  cancelAddAndEditFunction() {
    this.visibleAddAndEditPopup.close();
  }

  deleteFiledValueRequiredMsg: any;
  deleteValidation() {
    this.deleteFiledValueRequiredMsg = document.getElementById('deleteTextarea-required-msg') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.isProcessing = false;
      this.deleteFiledValue.style.border = '1px solid red';
      this.deleteFiledValueRequiredMsg.style.display = 'block';
    } else {
      this.deleteFiledValue.style.border = 'none';
      this.deleteFiledValueRequiredMsg.style.display = 'none';
    }
  }

  deleteScheduledTrainingId: any;
  openDeletePopup(deleteRowData: any) {
    this.operationFlag = 'DELETE';
    this.popupDataTitle.title = "Delete Instructor Training";
    this.isProcessing = true;
    this.appService.getScheduledTrainingById(deleteRowData.TRAINING_SCHEDULE_ID).subscribe((response: any) => {
      this.scheduledTrainingFieldData = response[0];
      this.isProcessing = false;
      if (this.scheduledTrainingFieldData.deleteReason != undefined) {
        this.scheduledTrainingFieldData.deleteReason = '';
      }
    })

    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  deleteScheduledTrainingData: any;
  deleteFiledValue: any;
  deleteFunction() {
    this.isProcessing = true;
    this.deleteFiledValue = document.getElementById('deleteTextarea') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.deleteValidation();
      this.isProcessing = false;
    } else {
      delete this.scheduledTrainingFieldData.actualStartDate;
      delete this.scheduledTrainingFieldData.actualEndDate;
      delete this.scheduledTrainingFieldData.scheduledStartDate;
      delete this.scheduledTrainingFieldData.scheduledEndDate;
      delete this.scheduledTrainingFieldData.approvalRequestedOn;
      delete this.scheduledTrainingFieldData.approvedOn;
      delete this.scheduledTrainingFieldData.notificationSentOn;
      delete this.scheduledTrainingFieldData.createdOn;
      delete this.scheduledTrainingFieldData.lastActionOn;
      delete this.scheduledTrainingFieldData.updatedOn;

      this.appService.deleteScheduledTraining(this.scheduledTrainingFieldData).subscribe({
        next: (Response: any) => {
          if (Response.resultType == 'S') {
            this.visibleDeletePopup.close();
            this.getcallMethod();
          }
          this.isProcessing = false;
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: Response.resultType == 'S' ? 5000 : undefined,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }, error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    }
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }

  goToDetailPage(editRowData: any) {
    this.previousData = editRowData;
    this.isProcessing = true;
    this.appService.getScheduledTrainingById(editRowData.TRAINING_SCHEDULE_ID).subscribe((response: any) => {
      this.scheduledTrainingFieldData = response[0];
      this.isProcessing = false;
      this.scheduledTrainingFieldData.isShowTrainingAssessmentFlag = this.isShowTrainingAssessmentFlag;
      this.scheduledTrainingFieldData.isFromDashboard = false;
      this.scheduledTrainingFieldData.allowUsersToTakeAssessmentAtApplication = this.scheduledTrainingFieldData.allowUsersToTakeAssessmentAtApplication == "Y";
      this.scheduledTrainingFieldData.allowUsersToTakeAssessmentAtApplication1 = this.scheduledTrainingFieldData.allowUsersToTakeAssessmentAtApplication;
      this.scheduledTrainingFieldData.scheduledStartDate = new Date(this.scheduledTrainingFieldData.scheduledStartDate);
      this.scheduledTrainingFieldData.scheduledEndDate = new Date(this.scheduledTrainingFieldData.scheduledEndDate);
      this.router.navigate(['/dashboard/scheduleTrainingDetail'], {
        state: {
          isShowTakeAssessmentField: this.isShowTrainingAssessmentFlag,
          trainingScheduleId: this.scheduledTrainingFieldData.trainingScheduleId,
          feedbackTemplateList: this.feedbackTemplateList
        }
      });
    })
  }

  searchTrainingParentCheckBox: boolean = false;
  searchTrainingChildCheckBoxs: boolean = false;
  searchTrainingChildCheckBoxsMenu: boolean = false;

  searchTrainingDataGridParentCheckBoxChecked(e: any) {
    const isChecked = !!e.target.checked;

    for (const trainingItem of this.getTmsTrainingDetailsTableData) {
      trainingItem.searchTrainingChildCheckBoxs = isChecked;
    }
  }

  getSelectedTrainingId: any;
  getSelectedTrainingName: any;
  getSelectedVersion: any;
  getSelectedDescription: any;
  previousTrainingData: any = {};
  searchTrainingChildCheckBoxChecked(e: any, listOfTrainingsVwDetails: any, idx: any) {

    if (e.target.checked) {
      listOfTrainingsVwDetails.searchTrainingChildCheckBoxs = true;
      this.getSelectedTrainingId = listOfTrainingsVwDetails.trainingId;
      this.getSelectedTrainingName = listOfTrainingsVwDetails.trainingName;
      this.getSelectedVersion = listOfTrainingsVwDetails.version;
      this.getSelectedDescription = listOfTrainingsVwDetails.description;
      this.previousTrainingData.searchTrainingChildCheckBoxs = false;
    } else {
      listOfTrainingsVwDetails.searchTrainingChildCheckBoxs = false;
      this.getSelectedTrainingId = null;
      this.getSelectedTrainingName = null;
      this.getSelectedVersion = null;
      this.getSelectedDescription = null;
    }
    this.previousTrainingData = listOfTrainingsVwDetails;

  }

  showUserSearchGrid: boolean;
  searchByTrainingName: any = null;
  searchByTrainingCode: any = null;
  searchByCategory: any = null;
  searchByLanguage: any = null;
  categoryValue: any;
  languageValue: any;
  searchTmsTrainingsVwDetails: any;
  getTmsTrainingDetailsTableData: any = [];

  searchTrainingFunction() {
    this.searchTrainingChildCheckBoxs = false;
    this.showUserSearchGrid = false;
    this.searchByTrainingName = null;
    this.searchByTrainingCode = null;
    this.searchByCategory = null;
    this.searchByLanguage = null;
    this.visibleSearchTrainingPopup = this.dialog.open(this.searchTraining, this.searchTrainingConfig);
  }

  addTrainingNameFunction() {
    this.scheduledTrainingFieldData.trainingId = this.getSelectedTrainingId;
    this.scheduledTrainingFieldData.trainingName = this.getSelectedTrainingName;
    this.scheduledTrainingFieldData.version = this.getSelectedVersion
    this.scheduledTrainingFieldData.trainingDetails = this.getSelectedDescription;
    this.visibleSearchTrainingPopup.close();
    this.isShowTrainingAssessmentFlag = false;
    this.isProcessing = true;
    this.appService.getContentsList(this.getSelectedTrainingId,
      this.getSelectedVersion).subscribe((data: any) => {
        this.isProcessing = false;
        this.isShowTrainingAssessmentFlag = data.some((item: any) => item.isQuestionContent == "Y");
      })
  }

  cancelSearchTrainingFunction() {
    this.getSelectedTrainingId = null;
    this.getSelectedTrainingName = '';
    this.getSelectedVersion = null;
    this.visibleSearchTrainingPopup.close();
  }

  searchTrainingGridDataFunction() {
    this.isProcessing = true;
    this.categoryValue = this.searchByCategory ?? null;
    this.languageValue = this.searchByLanguage ?? null;

    this.searchTmsTrainingsVwDetails = {
      trainingName: this.searchByTrainingName,
      trainingCode: this.searchByTrainingCode,
      category: this.selectedCategoryValue,
      language: this.selectedLanguageValue,
      trainingScheduleId: this.scheduledTrainingFieldData.trainingScheduleId
    };
    this.getTmsTrainingDetailsTableData = [];
    this.appService.searchTrainingsByConditionForScheduler(this.searchTmsTrainingsVwDetails).subscribe((response: any) => {
      this.getTmsTrainingDetailsTableData = [];
      const activeTrainings = response.filter((item: any) => item.status != 'Expired');
      this.getTmsTrainingDetailsTableData.push(...activeTrainings);

      this.showUserSearchGrid = true;
      this.isProcessing = false;
    })
  }

  resetSearchTrainingGridDataFunction() {
    this.isProcessing = true;
    this.searchByTrainingName = null;
    this.searchByTrainingCode = null;
    this.searchByCategory = null;
    this.searchByLanguage = null;
    this.getTmsTrainingDetailsTableData = [];
    this.showUserSearchGrid = false;
    this.isProcessing = false;
  }
  categoryDropdown: any = [];
  languageDropdown: any = [];
  modeDropdown: any = [];
  selectBoxeForCategory() {
    for (const category of this.dropDownForCategories) {
      this.categoryDropdown = this.categoryDropdown.concat({
        valueExp: category.trainingCategoryCode,
        displayExp: category.trainingCategoryName
      });
    }
  }

  selectBoxeForLanguage() {
    for (const language of this.dropDownForLangauge) {
      this.languageDropdown = this.languageDropdown.concat({
        valueExp: language.codelistCode,
        displayExp: language.codelistName
      });
    }
  }

  selectBoxeForMode() {
    for (const mode of this.dropDownForMode) {
      this.modeDropdown = this.modeDropdown.concat({
        valueExp: mode.codelistCode,
        displayExp: mode.codelistName
      });
    }
  }

  selectedCategoryValue: any;
  selectedLanguageValue: any;
  onCategorySelect(event: any, item: any) {
    if (event.isUserInput) {

      this.selectedCategoryValue = item?.valueExp ?? null;
    }
  }

  onCategorySelectOld(item: any) {

    this.selectedCategoryValue = item?.valueExp ?? null;
  }
  onCategoryRemoved(item: any) { }

  onLanguageSelect(event: any, item: any) {
    if (event.isUserInput) {

      this.selectedLanguageValue = item.valueExp;
    }
  }

  onLanguageSelectOld(item: any) {

    this.selectedLanguageValue = item.valueExp;
  }
  onLangaugeRemoved(item: any) { }


  searchUserParentCheckBox: boolean = false;
  searchUserChildCheckBoxs: boolean = false;
  searchUserChildCheckBoxsMenu: boolean = false;

  searchUserDataGridParentCheckBoxChecked(e: any) {
    const isChecked = !!e.target.checked;

    for (const user of this.getOneQmsUsersVwDetailsTableData) {
      user.searchUserChildCheckBoxs = isChecked;
    }
  }

  getSelectedUserId: any;
  getSelectedUserName: string;
  previousSelectedData: any = {};
  searchUserChildCheckBoxChecked(e: any, listOfUsersVwDetails: any, idx: any) {


    if (e.target.checked) {
      listOfUsersVwDetails.searchUserChildCheckBoxs = true;
      this.getSelectedUserId = listOfUsersVwDetails.userId;
      this.getSelectedUserName = listOfUsersVwDetails.userFullname;
      this.previousSelectedData.searchUserChildCheckBoxs = false;
    } else {
      listOfUsersVwDetails.searchUserChildCheckBoxs = false;
      this.getSelectedUserId = null;
      this.getSelectedUserName = '';
    }
    this.previousSelectedData = listOfUsersVwDetails;
  }

  searchByUserName: any = null;
  searchByFirstName: any = null;
  searchByLastName: any = null;
  searchByDesignationCode: any = null;
  searchByDepartmentCode: any = null;
  searchingByStatusCode: any = [];
  designationCodeValue: any;
  departmentCodeValue: any;
  statusCodeValue: any;
  searchOneQmsUserVwDetails: any;
  getOneQmsUsersVwDetailsTableData: any = [];

  searchUserFunction() {
    this.searchUserChildCheckBoxs = false;
    this.showUserSearchGrid = false;
    this.searchByUserName = null;
    this.searchByFirstName = null;
    this.searchByLastName = null;
    this.searchByDesignationCode = null;
    this.searchByDepartmentCode = null;
    this.visibleSearchUserPopup = this.dialog.open(this.searchUser, this.searchUserConfig);
  }

  addUserNameFunction() {
    this.scheduledTrainingFieldData.trainerId = this.getSelectedUserId;
    this.scheduledTrainingFieldData.trainerName = this.getSelectedUserName;
    this.visibleSearchUserPopup.close();
  }

  cancelSearchUserFunction() {
    this.getSelectedUserId = null;
    this.getSelectedUserName = '';
    this.visibleSearchUserPopup.close();
  }

  searchUserGridDataFunction() {
    this.getOneQmsUsersVwDetailsTableData = [];
    this.isProcessing = true;

    this.designationCodeValue = this.searchByDesignationCode ?? null;
    this.departmentCodeValue = this.searchByDepartmentCode ?? null;


    const searchByUserName = this.searchByUserName?.toUpperCase() ?? '';

    this.searchByUserName ??= '';

    this.searchOneQmsUserVwDetails = {
      userName: searchByUserName,
      firstName: this.searchByFirstName,
      lastName: this.searchByLastName,
      designationCode: this.designationCodeValue,
      departmentCode: this.departmentCodeValue,
      groupId: 0
    };
    this.appService.getTrainingsUsersList(this.searchOneQmsUserVwDetails).subscribe((response: any) => {
      this.getOneQmsUsersVwDetailsTableData = response;
      this.showUserSearchGrid = true;
      this.isProcessing = false;
    })
  }

  resetSearchUserGridDataFunction() {
    this.isProcessing = true;
    this.searchByUserName = null;
    this.searchByFirstName = null;
    this.searchByLastName = null;
    this.searchByDesignationCode = null;
    this.searchByDepartmentCode = null;
    this.getOneQmsUsersVwDetailsTableData = [];
    this.showUserSearchGrid = false;
    this.isProcessing = false;
  }

  selectBoxeForDesignationCode() {
    for (const designation of this.dropDownForDesignationCode) {
      // Preserving .concat() to ensure array reference updates for change detection
      this.designationCodeDropdown = this.designationCodeDropdown.concat({
        valueExp: designation.codelistName,
        displayExp: designation.codelistName
      });
    }
  }

  selectBoxeForDepartmentCode() {
    for (const department of this.dropDownForDepartmentCode) {
      this.departmentCodeDropdown = this.departmentCodeDropdown.concat({
        valueExp: department.codelistName,
        displayExp: department.codelistName
      });
    }
  }

  selectedDesignationValue: any;
  selectedDepartmentValue: any;
  onDesignationCodeSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {
        this.selectedDesignationValue = item.valueExp;
      } else {
        this.selectedDesignationValue = null;
      }
    }
  }

  onDesignationCodeSelectOld(item: any) {

    this.selectedDesignationValue = item.valueExp;
  }
  onDesignationCodeRemoved(item: any) { }

  onDepartmentCodeSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {
        this.selectedDepartmentValue = item.valueExp;
      } else {
        this.selectedDepartmentValue = null;
      }
    }
  }

  onDepartmentCodeSelectOld(item: any) {

    this.selectedDepartmentValue = item.valueExp;
  }
  onDepartmentCodeRemoved(item: any) { }

  selectedTrainingMode: any = null;
  selectedTrainingModeValue: any;

  templateSearchText: string = '';
  onTemplateSelect(event: any, item: any) {
    if (event.isUserInput) {
      console.log("")
    }
  }

  onModeSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {
        this.selectedTrainingModeValue = item.valueExp;
      } else {
        this.selectedTrainingModeValue = null;
      }
    }
  }

  sortedColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.scheduledTrainingDataForGrid.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA! < valueB!) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA! > valueB!) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }


  onModeSelectOld(item: any) {
    this.selectedTrainingModeValue = item.valueExp;
  }
  onModeRemoved(item: any) {
    this.selectedTrainingModeValue = null;
  }

  minEndDate = new Date();
  setVal(event: any) {
    this.scheduledTrainingFieldData.scheduledStartDate = new Date(event);
    this.minEndDate = event;
  }

  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;

  openAuditTrail(viewType: any, training: any) {
    this.auditTrail.gridName = 'SCHEDULED_TRAININGS';
    this.auditTrail.refNo = viewType == 'overAll' ? null : training.TRAINING_SCHEDULE_ID;
    this.auditTrail.report_And_Popup_Name = 'Instructor Training Audit Trail';
    this.dynamicAuditTrailComponent.triggerTrail(training);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = this.reportObj;
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = 'Instructor Training Report';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.reportObj.gridName, this.reportObj.tableOrViewName, null, 0)
  }

  onChildValueEmitted() {
    this.getcallMethod();
  };

  dynamicLabel: any = null;
  label: any = [];
  dynamicLabelCall() {
    this.isProcessing = true;
    const data = {
      tableName: this.reportObj.tableOrViewName,
      moduleName: null,
      gridName: this.reportObj.gridName,
      groupId: 0,
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (data: any) => {
        this.label = data;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = user.changedFieldName;
          return acc;
        }, {});
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
      }
    });
  }

  totalNumberOfData: any = [];
  hightSection: any;
  getListOfGridChartCountsDetails: any = [];

  getChartCounts(chartData: any) {
    if (chartData) {
      this.chartfunctionBody(chartData);
    } else {
      let data = {

      };
      this.appService.getSchuduleTrainingGridChartCountsDetails(data).subscribe((Response: any) => {
        this.chartfunctionBody(Response);
      });
    }
  }

  chartfunctionBody(chartData: any) {
    this.getListOfGridChartCountsDetails = [];
    const keys = Object.keys(chartData[0]);
    const statusMapping: {
      [key: string]: {
        id: number;
        status: string;
        colorCode: string;
      };
    } = {
      total: { id: 1, status: 'Total', colorCode: '#0080FF' },
      closed: { id: 2, status: 'Closed', colorCode: '#009C40' },
      active: { id: 3, status: 'Active', colorCode: '#ECFF00' },
      others: { id: 4, status: 'Others', colorCode: '#9D97FF' },
      overdue: { id: 5, status: 'Overdue', colorCode: '#FF0000' },
    };
    this.getListOfGridChartCountsDetails = [];
    for (const key of keys) {
      if (statusMapping[key]) {
        this.getListOfGridChartCountsDetails.push({
          ...(statusMapping[key] as { id: number; status: string; colorCode: string }), // Type assertion
          count: chartData[0][key] ?? 0,
        });
      }
    }

    this.totalNumberOfData = this.getListOfGridChartCountsDetails.filter((x: any) => x.status === 'Total');
    for (const item of this.getListOfGridChartCountsDetails) {
      if (item.status !== 'Total') {
        if (item.count && item.count > 0 && this.totalNumberOfData[0]?.count && this.totalNumberOfData[0].count > 0) {
          item.percentage = Math.round((item.count / this.totalNumberOfData[0].count) * 100);
        } else {
          item.percentage = 0;
        }
      }
      if (!item.count) {
        item.count = 0;
      }
    }

    this.getListOfGridChartCountsDetails.sort((a: any, b: any) => a.id - b.id);
    console.log('Chat Data - ', this.getListOfGridChartCountsDetails);

    this.preIdAttibute = '';

    const getInitialActiveValue = this.getListOfGridChartCountsDetails.find(
      (item: { status: string }) => item.status === 'Active'
    );

    if (getInitialActiveValue) {
      this.qmsservice.activity.chartStatus = getInitialActiveValue.status;
      this.onClickOnChart(getInitialActiveValue.id, getInitialActiveValue, "Manually");
    }
  }

  currentIdAttibute: any;
  preIdAttibute: any = '';
  styleMiniChartContainer: any;
  onClickOnChart(event: any, data: any, from: any) {

    if (this.preIdAttibute != '') {
      this.styleMiniChartContainer = document.getElementById(this.preIdAttibute) as HTMLInputElement;
      this.styleMiniChartContainer.style.boxShadow = '';
    }

    if (event.currentTarget) {
      this.currentIdAttibute = event.currentTarget.id;
      this.preIdAttibute = event.currentTarget.id;
      this.qmsservice.activity.chartStatus = data.status;
    } else {
      this.currentIdAttibute = "" + event + "";
      this.preIdAttibute = "" + event + "";
    }

    this.styleMiniChartContainer = document.getElementById(this.currentIdAttibute) as HTMLInputElement;

    this.hightSection = data.status;
    this.getcallMethod();
  }
  focusEmpty() {
    console.log();
  }

}
